<template>
  <div class="text-center mt-12">
    <p v-if="withText" class="loading-message">
      Andmete laadimine
    </p>
    <v-progress-circular
      :size="dimensions.size"
      color="primary"
      indeterminate
      :width="dimensions.width"
    />
  </div>
</template>

<script>
export default {
  props: {
    withText: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      validator: function(value) {
        return ['small', 'large'].includes(value)
      },
      default: 'small'
    }
  },
  computed: {
    dimensions() {
      return this.size === 'small'
        ? { size: 40, width: 4 }
        : { size: 70, width: 6 }
    }
  }
}
</script>
